export default function HowItWorks() {
  const steps = [
    {
      num: '01',
      title: 'Search Products',
      desc: 'Use the spreadsheet to browse through thousands of curated items organized by category.',
      icon: 'ri-search-line',
    },
    {
      num: '02',
      title: 'Compare Options',
      desc: 'Review product details, specifications, and pricing side by side in one view.',
      icon: 'ri-scales-3-line',
    },
    {
      num: '03',
      title: 'Review Information',
      desc: 'Check product descriptions, images, and availability before making your choice.',
      icon: 'ri-file-list-3-line',
    },
    {
      num: '04',
      title: 'Continue to Vigorbuy',
      desc: 'Follow the link to explore the full catalog and complete your shopping journey.',
      icon: 'ri-external-link-line',
    },
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold uppercase tracking-widest text-accent-500">Process</span>
          <h2 className="mt-2 text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            How It <span className="text-primary-500">Works</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-md mx-auto">
            Four simple steps from discovery to purchase
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, idx) => (
            <div
              key={idx}
              className="relative bg-background-50 rounded-xl border border-background-200/60 p-6 md:p-7 group hover:border-primary-300/50 transition-all duration-300"
            >
              <span className="text-5xl font-heading font-bold text-background-200 absolute top-4 right-5 select-none">
                {step.num}
              </span>
              <div className="relative">
                <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                  <i className={`${step.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950">{step.title}</h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}